module.exports = __webpack_public_path__ + "static/media/team@3x.87ab07b3.jpg";